import imgGrande from "../../assets/alfapepe.png";
import imgGrande6 from "../../assets/alfapeseis.png";

export const shopitems = [
  {
    id: "0",
    title: "Alfajor",
    unit_price: 100,
    description: "No apto para celíacos ni diabéticos.",
    imagen: imgGrande,
  },
  {
    id: "1",
    title: "Caja de 6 Alfajores",
    unit_price: 550,
    description: "6 alfajores para compartir.",
    imagen: imgGrande6,
  },
  // {
  //   id: "2",
  //   title: "8 Sorrentinos de Salmonete, Ricotta y Pistacchio",
  //   unit_price: 320,
  //   description:
  //     "Masa de trigo coloreada, relleno de salmón criollo ahumado, ricotta y pistacchio. Va bien com crema o burro.",
  //   imagen: imgGrande,
  // },
  // {
  //   id: "3",
  //   title: "8 Sorrentinos Verdes",
  //   unit_price: 280,
  //   description:
  //     "Masa blanca con relleno de espinaca, puerro, parmesano y nueces. Va bien con pomodoro.",
  //   imagen: imgGrande,
  // },
  // {
  //   id: "4",
  //   title: "Salsa BBQ Suavemente Picante",
  //   unit_price: 200,
  //   description: "Sachet de aluminio 500 ml",
  //   imagen: imgChica,
  // },
];
